import { API, axios, SendRequest} from '@/imports-files/pages/clients/activities/index';


export class MyTeamService extends SendRequest {
  async getTeamDetails(params) 
  {
    try {
      const result = await axios.get(API.client.activities.GET_MY_TEAM,
        {
          params: params,
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async addTeamMembers(params){
    try {
      const result = await axios.post(API.client.activities.ADD_TEAM_MEMBERS,
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }
}
